import { AddMenuItemByTempIdAction, CreateOrderItem, OrderingInitialState } from '@reducers/ordering/types';

const addItemToOrder = (menus: CreateOrderItem[], tempId: string): CreateOrderItem[] =>
  menus.map((item) => {
    if (item.tempId === tempId) {
      return {
        ...item,
        count: (item.count || 0) + 1,
        orderItemToppings: item?.orderItemToppings?.map((x) => ({
          ...x,
          count: (item.count || 0) + 1,
        })),
      };
    }
    return item;
  });

const EditedOrder = (state: OrderingInitialState, tempId: string): OrderingInitialState => {
  // const canAdd = state?.orderState.order && state?.orderState.order?.orderHistoryState === OrderState.SUBMITTED;
  const updatedMenuItem = state?.orderState.menus?.find((x) => x.tempId === tempId);
  // const orderMenuItem = state?.orderState.order?.orderItems?.find((x) => x.id === tempId);
  const menuItemsCount = state.orderState.menus?.map((item) => item.count || 0).reduce((a, b) => a + b, 1);

  if (updatedMenuItem) {
    if (updatedMenuItem?.count && updatedMenuItem?.count > 0) {
      return {
        ...state,
        orderState: {
          ...state.orderState,
          menus: state?.orderState.menus?.map((item) => {
            let count = 0;
            // if (!canAdd) {
            //   count = (item.count || 0) + 1 > (orderMenuItem?.count || 0) ? item.count || 0 : (item.count || 0) + 1;
            // } else {
            //   count = (item.count || 0) + 1;
            // }
            count = (item.count || 0) + 1;
            if (item.tempId === tempId) {
              return {
                ...item,
                count,
                orderItemToppings: item?.orderItemToppings?.map((x) => ({
                  ...x,
                  count,
                })),
                toppings: item?.orderItemToppings?.map((x) => ({
                  ...x,
                  count,
                })),
              };
            }
            return item;
          }),
          menuItemsCount,
        },
      };
    }
  }

  return { ...state };
};

export const addMenuItemByTempId = (
  state: OrderingInitialState,
  action: AddMenuItemByTempIdAction
): OrderingInitialState => {
  if (state.orderState.isEdited) {
    return EditedOrder(state, action.payload.tempId);
  }
  const menuItemsCount = state.orderState.menus?.map((item) => item.count || 0).reduce((a, b) => a + b, 1);
  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus: addItemToOrder(state?.orderState.menus, action.payload.tempId),
      menuItemsCount,
    },
  };
};
